import { Controller } from "@hotwired/stimulus"

// Admin projects search/filter form: submits after a short pause while typing,
// or right away when a filter changes. A search covers every project, so the
// filters are dimmed while it has text, and picking a filter clears it.
// Sort/direction are re-read from the URL first, since column headers
// update them by navigating the results frame.
export default class extends Controller {
  static targets = ["sort", "direction", "query", "filters"]
  static values = { delay: { type: Number, default: 300 } }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    if (this.hasFiltersTarget) {
      this.filtersTarget.classList.toggle("opacity-40", this.queryTarget.value.trim() !== "")
    }
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), this.delayValue)
  }

  filter() {
    if (this.hasQueryTarget && this.queryTarget.value !== "") {
      this.queryTarget.value = ""
      this.filtersTarget.classList.remove("opacity-40")
    }
    this.submit()
  }

  submit() {
    clearTimeout(this.timeout)
    const params = new URLSearchParams(window.location.search)
    if (this.hasSortTarget && params.has("sort")) this.sortTarget.value = params.get("sort")
    if (this.hasDirectionTarget && params.has("direction")) this.directionTarget.value = params.get("direction")
    this.element.requestSubmit()
  }
}
